import React, { useState } from 'react';
import { Row, Col} from "react-bootstrap"
import { useTranslation } from "react-i18next";
import { DefaultButton, PrimaryButton } from '@fluentui/react/lib/Button';
import { Panel, PanelType } from '@fluentui/react/lib/Panel';
import { useBoolean } from '@fluentui/react-hooks';
import { Dialog, DialogFooter, DialogType } from '@fluentui/react/lib/Dialog';
import { useSelector } from 'react-redux';
import CLabel from '../../../Common/CLabel';
import i18next from 'i18next';
import moment from 'moment';

const SidePanelContractInformationBulkUpload = (props) => {
    const { t } = useTranslation();

    const inputParam_IsPanelOpen = props.isPanelOpen;
    const inputParam_SetterIsPanelOpen = props.setterIsPanelOpen;
    const inputParam_Contract = props.contract;

    const [isDialogVisible, { setTrue: showDialog, setFalse: hideDialog }] = useBoolean(false);

    const onHideDialog = (ev) => {
        ev.preventDefault();
        inputParam_SetterIsPanelOpen(true);
        hideDialog();
    };

    const onDismissPanel = () => {
        inputParam_SetterIsPanelOpen(false);
    };

    const onHideDialogAndPanel = () => {
        onDismissPanel();
        hideDialog();
    };
    
    const onClosePanel = () => {
        onDismissPanel();
    };

    const onRenderFooterContent = () => {
        return <div className='d-flex'>
            <DefaultButton onClick={onClosePanel}>{t('data-lang-btn-close')}</DefaultButton>
        </div> 
    };

    return (
        <div>
            <Panel
                isOpen={ inputParam_IsPanelOpen }
                isLightDismiss={ true }
                onLightDismissClick={ showDialog }
                onDismiss={ onDismissPanel }
                headerText={ t('data-lang-boxname-contractinformation') }
                closeButtonAriaLabel={ t('data-lang-btn-close') }
                isFooterAtBottom={ true }
                onRenderFooterContent={ onRenderFooterContent }
                customWidth={ PanelType.medium }
                type={ PanelType.medium }
            >
                <>
                {
                    (inputParam_Contract) &&
                    <>
                        <Row className="pt-3">
                            <Col xl={12}>
                                <CLabel labelText={t('data-lang-lbl-amount')} labelValue={inputParam_Contract.amount && parseFloat(inputParam_Contract.amount.toFixed(2)).toLocaleString(i18next.language)} linked={false} linkedIconProps={null} linkedEventFire={null} linkedEventParam={null}/>
                            </Col>
                        </Row>
                        <Row className="pt-3">

                            <Col xl={12}>
                                <CLabel labelText={t('data-lang-lbl-currency')} labelValue={inputParam_Contract.currencyName} linked={false} linkedIconProps={null} linkedEventFire={null} linkedEventParam={null}/>
                            </Col>
                        </Row>
                        <Row className="pt-3">
                            <Col xl={12}>
                                <CLabel labelText={t('data-lang-lbl-startdate')} labelValue={inputParam_Contract.startDate && moment(inputParam_Contract.startDate).format("DD/MM/YYYY")} linked={false} linkedIconProps={null} linkedEventFire={null} linkedEventParam={null}/>
                            </Col>
                        </Row>
                        <Row className="pt-3">
                            <Col xl={12}>
                                <CLabel labelText={t('data-lang-lbl-enddate')} labelValue={inputParam_Contract.endDate && moment(inputParam_Contract.endDate).format("DD/MM/YYYY")} linked={false} linkedIconProps={null} linkedEventFire={null} linkedEventParam={null}/>
                            </Col>
                        </Row>
                        <Row className="pt-3">
                            <Col xl={12}>
                                <CLabel labelText={t('data-lang-lbl-endowment')} labelValue={inputParam_Contract.endowment} linked={false} linkedIconProps={null} linkedEventFire={null} linkedEventParam={null}/>
                            </Col>
                        </Row>
                        <Row className="pt-3">
                            <Col xl={12}>
                                <CLabel labelText={t('data-lang-lbl-businessunitName')} labelValue={inputParam_Contract.businessUnitName} linked={false} linkedIconProps={null} linkedEventFire={null} linkedEventParam={null}/>
                            </Col>
                        </Row>
                        <Row className="pt-3">
                            <Col xl={12}>
                                <CLabel labelText={t('data-lang-lbl-status')} labelValue={inputParam_Contract.statusName} linked={false} linkedIconProps={null} linkedEventFire={null} linkedEventParam={null}/>
                            </Col>
                        </Row>
                        <Row className="pt-3">
                            <Col xl={12}>
                                <CLabel labelText={t('data-lang-lbl-segment')} labelValue={inputParam_Contract.segmentName} linked={false} linkedIconProps={null} linkedEventFire={null} linkedEventParam={null}/>
                            </Col>
                        </Row>
                        <Row className="pt-3">
                            <Col xl={12}>
                                <CLabel labelText={t('data-lang-lbl-category')} labelValue={inputParam_Contract.categoryName} linked={false} linkedIconProps={null} linkedEventFire={null} linkedEventParam={null}/>
                            </Col>
                        </Row>
                    </>
                }
                </>
                <Dialog
                    hidden={!isDialogVisible}
                    onDismiss={onHideDialog}
                    dialogContentProps={{
                        type: DialogType.normal,
                        title: t('data-lang-msg-close-panel'),
                    }}
                    modalProps={{
                        isBlocking: true,
                        styles: { main: { maxWidth: 450 } },
                    }}
                    >
                    <DialogFooter>
                        <PrimaryButton onClick={onHideDialogAndPanel} text={t('data-lang-lbl-yes')} />
                        <DefaultButton onClick={onHideDialog} text={t('data-lang-lbl-no')} />
                    </DialogFooter>
                </Dialog>
            </Panel>
        </div>
    );
};

export default SidePanelContractInformationBulkUpload;